import styled from "styled-components";
import {
  COLORS,
  FONT_SIZE,
  TableCell,
  TableHeaderRow,
} from "../../../../constants/Styles";

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0.5rem;
`;

export const Subtitle = styled.div`
  font-size: ${FONT_SIZE.size18};
  text-align: center;
  margin-bottom: 1rem;
`;

export const InventoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
`;

export const InventoryDetailsContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-end;
  flex-wrap: wrap;
`;

export const InventoryHeaderRow = styled(TableHeaderRow)`
  font-size: 11px;
`;

export const ErrorText = styled.div`
  color: ${COLORS.error};
`;

export const InventoryTableCell = styled(TableCell)`
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

export const CellRow = styled.div`
  display: flex;
  gap: 1rem;
`;

export const TablesGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: center;
  width: 100%;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PriceBreaksDetailsContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

export const OverrideHistoryRecordContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
